import { Typography, styled } from "@mui/material";
import { clientConfigFn } from "clientConfig";
export const NavbarText = styled(Typography)(() => ({
    color: clientConfigFn().navbarTextColor,
    marginLeft: "16px",
    flex: 1,
}));
